import { axiosInstance } from '../request';
export const getPrompts = async () => {
    const response = await axiosInstance.get('/api/v1/user_prompts');
    return response.data;
};
export const getDefaultPrompts = async () => {
    const response = await axiosInstance.get(`/api/v1/prompts/default`);
    return response.data;
};
export const updatePrompts = async (input) => {
    const response = await axiosInstance.patch('/api/v1/user_prompts', input);
    return response.data;
};
//# sourceMappingURL=prompts.api.js.map